import React, { useEffect } from 'react';
import { Card, Row, Col } from 'antd';
import { UserOutlined, AppstoreOutlined, ForkOutlined, FileTextOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const DashboardCard = ({totalArticles,totalCategories,totalUsers,totalSubCategories}) => {
  const navigate = useNavigate();
 const roleType = localStorage.getItem('roleType'); // Get role type from localStorage

  // Redirect if the user does not have a valid role
  useEffect(() => {
    if (!roleType || (roleType !== 'ADMIN' && roleType !== 'EDITOR')) {
      navigate('/'); // Redirect to home if role is invalid
    }
  }, [roleType, navigate]);

  

  const handleCardClick = (url) => {
     
    if (roleType === 'ADMIN') {
      navigate(url);
    }
  };

  const stats = [
    { title: 'Number of Users', value: totalUsers, icon: <UserOutlined />, color: 'green', url: '/admin/users' },
    { title: 'Total Categories', value: totalCategories, icon: <AppstoreOutlined />, color: 'blue', url: '/admin/categories' },
    { title: 'Sub-Categories', value: totalSubCategories, icon: <ForkOutlined />, color: 'orange', url: '/admin/sub-categories' },
    { title: 'Articles', value: totalArticles, icon: <FileTextOutlined />, color: 'red', url: '/admin/articles' },
  ];

  return (
    <div style={{ padding: '24px', backgroundColor: '#fff' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '24px' }}>Dashboard</h2>
      <Row gutter={[16, 16]}>
        {stats.map((stat, index) => (
          <Col xs={24} sm={12} md={12} lg={12} key={index} >
            <Card 
              onClick={() => handleCardClick(stat.url)}
              style={{
                textAlign: 'center',
                borderColor: stat.color,
                minHeight: '30vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '16px',
                cursor: 'pointer',
              }}
            >
              <div style={{ fontSize: '48px', color: stat.color }}>{stat.icon}</div>
              <h3 style={{ marginTop: '16px', fontSize: '32px', color: stat.color }}>{stat.value}</h3>
              <p style={{ fontSize: '18px', fontWeight: 'bold', margin: '0' }}>{stat.title}</p>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default DashboardCard;
